/*
 * @Author: Wei Guojun 
 * @Date: 2021-07-26 13:55:27 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2021-07-26 14:44:28
 */

<template>
<div>
  <ul class="menu">
    <li v-for="(item,index) in menuList" :key="index" :class="{'active':menu_index===index}" @click="menu_index=index">{{item.label}}</li>
    <div class="title">(签收统计：2021-07-10 - 2021-07-25)</div> 
  </ul>    
  <formTable></formTable>
</div>
</template>
<script>
import formTable from '@/components/formTable.vue';
export default {
    name:'addressMenu',
    data(){
        return{
            menuList:[
                {label:'待揽件',value:0},
                {label:'未签收',value:1},
                {label:'已签收',value:1}
            ],
            menu_index:0,    
        }
    },
    components:{
        formTable,
    },
    methods:{

    }
}
</script>
<style lang="stylus" scoped>
.menu{
     display flex;
     justify-content flex-start;  
     background-color #f5f5f5; 
     .title{
        line-height 70px
     }
     li{
        height: 70px;
        line-height: 70px;
        margin-left: 20px;
        cursor: pointer;
        position: relative;
        margin-right: 20px;     
        font-size 18px;
        font-weight 700;    
        color #737373;
        &::after {
            position: absolute;
            background: #ffffff;
            content: '';
            left: 50%;
            bottom: 0;
            height: 2px;
            width: 0;
        }
     }
     .active{
        transition: all 0.3s;
        color: #1c8bf6;
        position: relative;   
        &::after {
            transition: all 0.3s;
            background: #1C8BF6;
            width: 100%;
            left: 0;
        }
    }
} 
</style>